var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.away),expression:"away"}],staticClass:"relative",on:{"click":_vm.toggle}},[_vm._t("toggler",function(){return [_c('button',[_vm._v("Toggle")])]}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }